import { render, staticRenderFns } from "./Deskinglog.vue?vue&type=template&id=d596aa72"
import script from "./Deskinglog.vue?vue&type=script&lang=js"
export * from "./Deskinglog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports